import SchoolPage from './SchoolPage'


export default SchoolPage
